import Vue from 'vue'
Vue.prototype.$bus = Vue.prototype.$bus || new Vue()
